import axios from "axios";

import { formPostService } from "services/form";

import { IFormPost } from "./interface";

interface IData {
  data: number;
  errors: [];
  message: string;
  ok: boolean;
}

export const post = async (item: IFormPost, endPoint: string) => {
  try {
    const { data } = await formPostService.postSimpleForm({
      endPoint: `${endPoint.replace(/\/$/, '')}/Add`,
      object: item,
    });

    if (typeof data === "string" && data.includes("403")) {
      const forbiddenError = new Error("PERMISSION_DENIED");
      (forbiddenError as any).status = 403;
      throw forbiddenError;
    }

    if (data?.ok === false && data?.message?.includes("403")) {
      const forbiddenError = new Error("PERMISSION_DENIED");
      (forbiddenError as any).status = 403;
      throw forbiddenError;
    }

    const dataReturn: IData = data;

    if (Array.isArray(dataReturn.errors) && dataReturn.errors.length === 0) {
      item.id = dataReturn.data;
      return item;
    } else {
      throw new Error(dataReturn.message);
    }
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response?.status === 403) {
      const forbiddenError = new Error("PERMISSION_DENIED");
      (forbiddenError as any).status = 403;
      throw forbiddenError;
    }

    if (error?.message) {
      throw error;
    }

    throw new Error("Erro inesperado no post");
  }
};

export const put = async (item: IFormPost, endPoint: string) => {
  try {
    const response = await formPostService.putSimpleForm({
      endPoint: `${endPoint.replace(/\/$/, '')}/Update`,
      object: item,
    });

    if (typeof response?.data === "string" && response.data.includes("403")) {
      const forbiddenError = new Error("PERMISSION_DENIED");
      (forbiddenError as any).status = 403;
      throw forbiddenError;
    }

    if (
      !("errors" in response?.data) ||
      !Array.isArray(response?.data.errors)
    ) {
      throw new Error("Resposta inesperada no PUT");
    }

    const dataReturn: IData = response.data;

    if (dataReturn.errors.length === 0) {
      return item;
    } else {
      throw new Error(dataReturn.message);
    }
  } catch (error: any) {
    if (error?.message === "PERMISSION_DENIED" || error?.status === 403) {
      const forbiddenError = new Error("PERMISSION_DENIED");
      (forbiddenError as any).status = 403;
      throw forbiddenError;
    }

    throw new Error("Erro inesperado no put");
  }
};
